import {pgettext} from 'topmeteo/utils/i18n';

import {getNextImage, getPreviousImage} from '../../general/selectors';

import Button from './ChangeImageButton';

const NextLabel = pgettext('skip', '+h');
const PreviousLabel = pgettext('skip', '-h');

const Buttons = [
    {id: 'prev', label: PreviousLabel, action: getPreviousImage},
    {id: 'next', label: NextLabel, action: getNextImage},
];

const SwitchIndex = () => Buttons.map(({id, label, action}) => (
    <Button key={id} className={`${id} index`} label={label} action={action} arrows={1} />
));

export default SwitchIndex;
